(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["inksole-bundle-builder"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('inksole-bundle')) {
  customElements.define('inksole-bundle', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-add-bundle]');
      this.error = this.querySelector('[data-bundle-error]');
      this.productContainer = document.getElementById(`ProductInfo-${this.dataset.sectionId}`);
      this.products = JSON.parse(this.querySelector('[data-bundle-products]')?.textContent || '[]');
      this.querySelectorAll('[data-bundle-design-option]').forEach((card) => {
        card.addEventListener('click', () => this.selectDesign(card));
      });
      this.button?.addEventListener('click', () => this.addBundle());
    }
    selectDesign(card) {
      const pair = card.dataset.bundleDesignOption;
      this.querySelectorAll(`[data-bundle-design-option="${pair}"]`).forEach((option) => {
        option.setAttribute('aria-pressed', String(option === card));
      });
      const variantSelect = this.querySelector(`[data-bundle-pair="${pair}"]`);
      const product = this.products[Number(card.dataset.productIndex)];
      variantSelect.replaceChildren(new Option(this.dataset.variantMessage, ''));
      product.variants.filter((variant) => variant.available).forEach((variant) => {
        variantSelect.add(new Option(variant.title.replace(/\s*⚡\s*Ready/gi, ''), variant.id));
      });
      variantSelect.disabled = false;
    }
    getCurrentVariantId() {
      return this.productContainer?.querySelector('form[action*="/cart/add"] input[name="id"]')?.value;
    }
    async addBundle() {
      const currentVariant = this.getCurrentVariantId();
      const selections = [...this.querySelectorAll('[data-bundle-pair]')].map((select) => select.value);
      if (!currentVariant || selections.some((value) => !value)) {
        this.showError(this.dataset.incompleteMessage);
        return;
      }
      this.error.hidden = true;
      this.button.disabled = true;
      this.button.textContent = this.dataset.addingMessage;
      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: {'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({items:[currentVariant, ...selections].map((id) => ({id,quantity:1}))})
        });
        if (!response.ok) throw new Error(this.dataset.unavailableMessage);
        window.location.assign(`${window.Shopify.routes.root}cart`);
      } catch (error) {
        this.showError(error.message || this.dataset.errorMessage);
        this.button.disabled = false;
        this.button.textContent = this.dataset.buttonMessage;
      }
    }
    showError(message) {
      this.error.textContent = message;
      this.error.hidden = false;
      this.error.focus?.();
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["inksole-purchase-help"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('inksole-purchase-bar')) {
  customElements.define('inksole-purchase-bar', class extends HTMLElement {
    connectedCallback() {
      const container = document.getElementById(`ProductInfo-${this.dataset.sectionId}`);
      const button = container?.querySelector('button[name="add"]');
      if (!button) return;
      const simplifyReadyLabels = () => {
        container.querySelectorAll('label, option, [data-selected-value]').forEach((element) => {
          element.childNodes.forEach((node) => {
            if (node.nodeType === Node.TEXT_NODE) node.textContent = node.textContent.replace(/\s*⚡\s*Ready/gi, '');
          });
        });
      };
      simplifyReadyLabels();
      this.labelObserver = new MutationObserver(simplifyReadyLabels);
      this.labelObserver.observe(container, {childList:true, subtree:true});
      this.observer = new IntersectionObserver(([entry]) => {
        this.dataset.visible = String(!entry.isIntersecting && entry.boundingClientRect.bottom < 0);
      });
      this.observer.observe(button);
      this.querySelector('a').addEventListener('click', () => {
        const option = container.querySelector('variant-selects input:checked, variant-selects select');
        setTimeout(() => option?.focus({preventScroll:true}), 250);
      });
    }
    disconnectedCallback() { this.observer?.disconnect(); this.labelObserver?.disconnect(); }
  });
}
  } catch(e) { console.error(e); }
})();

})();
